<template>
  <RevDialog
    :class="dialogClass"
    :name="MODAL_NAMES.DEALS_MODAL"
    :title="i18n(translations.modalHeader)"
    @open="handleOpen"
  >
    <template #body>
      <RevLoadingScreen
        v-if="pending"
        class="h-full"
        :text="i18n(translations.loading)"
      />
      <div
        v-else-if="products?.length === 0"
        class="flex h-full flex-col justify-center"
      >
        <p class="text-static-default-hi heading-1 mb-8">
          {{ i18n(translations.emptyTitle) }}
        </p>
        <p class="text-static-default-low body-1">
          {{ i18n(translations.emptyDescription) }}
        </p>
      </div>
      <div v-else-if="products" class="space-y-16">
        <ProductCardCarousel
          product-granularity="backbox"
          :products
          @add-to-cart="handleProductCardAction"
        />
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDialog } from '@ds/components/Dialog'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { closeModal } from '@ds/components/ModalBase'

import ProductCardCarousel from '@backmarket/nuxt-layer-recommendation/ProductCardCarousel.vue'

import { useDealsModal } from '../../../composables/useDealsModal'

import { MODAL_NAMES } from './DealsModal.constants'
import translations from './DealsModal.translations'

const i18n = useI18n()

// 64px = page horizontal gutter (32px) × 2 sides
const dialogClass = 'md:!w-[calc(100%-64px)]'

const { productId } = defineProps<{
  productId: string
  productName: string
}>()

const {
  data: products,
  pending,
  refresh: fetchProducts,
} = useDealsModal(productId)

function handleOpen() {
  fetchProducts()
}

function handleProductCardAction() {
  closeModal(MODAL_NAMES.DEALS_MODAL)
}
</script>
